export const searchView = {
  Grid: 'grid',
  List: 'list',
} as const;
export type SearchView = typeof searchView[keyof typeof searchView];
